module.exports = __webpack_public_path__ + "img/titleSaas.7b98699d.png";